export default function ajaxLoadMore(btnSelector, listSelector, params) {
  // attach handler to load more button
  $(btnSelector).click(function(e) {
    e.preventDefault();
    var post_type = false;

    if ($(this).hasClass('disabled')) return;

    var button = $(this),
      goTopButton = $('.component-btn-load-more .btn-go-to-top'),
      defaultText = $(this).html(),
      data = {
        action: 'loadmore',
        query: params.posts,
        page: params.current_page,
        item_template: params.item_template,
      };

    try {
      var postQuery = $.parseJSON(params.posts);
      post_type = postQuery.post_type[0];
    } catch (err) {
      // console.error(err);
    }

    $.ajax({
      url: params.ajaxurl,
      data: data,
      type: 'POST',
      beforeSend: function() {
        button.text('Loading...');
      },
      success: function(data) {
        if (data) {
          button.text(defaultText);
          params.current_page++;

          $(listSelector).append(data);

          if (params.current_page == params.max_page) {
            button.hide();
            goTopButton.show();
          }

          if (post_type == 'news') {
            button.hide();
            goTopButton.show();
          }
        } else {
          button.hide();
          goTopButton.show();
        }
      },
      complete: function() {
        // Reinit macy grid on news template
        if (window.macyGrid) {
          window.macyGrid.recalculate();

          setTimeout(() => {
            window.macyGrid.reInit();
          }, 1000);
        }
      },
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/util/ajaxLoadMore.js